const middleware = {}

middleware['admin'] = require('../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['loggedIn'] = require('../middleware/loggedIn.js')
middleware['loggedIn'] = middleware['loggedIn'].default || middleware['loggedIn']

export default middleware
